/* eslint-disable lingui/no-unlocalized-strings, lingui/text-restrictions */
import { ArrowRight, Check, MessageSquareText, Mic2 } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";

import { useAuthStore } from "@/client/stores/auth";

import { careerStory, StoryIdentity } from "./career-story";

export const SolutionsSection = () => {
  const { user } = useAuthStore();
  const [revised, setRevised] = useState(false);
  return (
    <section id="practice-interviews" className="folio-section folio-interview">
      <div className="folio-shell">
        <div className="folio-section-heading">
          <div>
            <p className="folio-eyebrow">Practice Interview</p>
            <h2>Practice the conversation. Not just the answer.</h2>
          </div>
          <p>
            Your AI interviewer asks, listens, and gives you space to respond. Practice out loud
            with questions relevant to your role, then review your transcript and feedback to see
            what to improve.
          </p>
        </div>
        <div className="practice-workbench">
          <div className="practice-question">
            <p className="folio-label">
              <Mic2 size={14} /> AI interviewer / sample question
            </p>
            <h3>{careerStory.question}</h3>
            <StoryIdentity detail="Spoken practice · illustrative transcript" />
          </div>
          <div className="practice-response">
            <div className="practice-switch" role="group" aria-label="Compare example answers">
              <button type="button" aria-pressed={!revised} onClick={() => setRevised(false)}>
                First answer
              </button>
              <button type="button" aria-pressed={revised} onClick={() => setRevised(true)}>
                With more context <ArrowRight size={14} />
              </button>
            </div>
            <div className="practice-transcript" aria-live="polite">
              <span className="folio-label">Avery’s illustrative answer</span>
              <p>
                “
                {revised ? (
                  <>
                    In onboarding research,{" "}
                    <mark>I noticed people hesitated at the first decision.</mark> I proposed one
                    guided next step, then tested the prototype with new users before we built it.
                  </>
                ) : (
                  <>
                    We redesigned onboarding. <mark>I worked with the team,</mark> and we made the
                    experience simpler.
                  </>
                )}
                ”
              </p>
            </div>
            <div className={`practice-feedback${revised ? " is-revised" : ""}`} aria-live="polite">
              {revised ? <Check size={19} /> : <MessageSquareText size={19} />}
              <div>
                <p className="folio-label">
                  {revised ? "What is clearer now" : "Example feedback"}
                </p>
                <p>
                  {revised
                    ? "The observation, Avery’s own decision, and the way it was tested are all visible."
                    : careerStory.feedback}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="folio-section-bottom">
          <span className="folio-example-note">
            An example of reviewing spoken answers. Your session uses your own experience.
          </span>
          <Link
            className="folio-text-link"
            to={user ? "/dashboard/practice-interview" : "/practice-interview"}
          >
            Try a Practice Interview <ArrowRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
};
